import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type gps
 */
const GPSRender = ({ gpsTemplate, onRemove, isEditable }) => {
  return (
    <BasicRender
      datasetTemplate={gpsTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

export default GPSRender;
